export const frontends = {
  CP: 1,
}
